import PointWeeklyInformation from './PointWeeklyInformation'

export default PointWeeklyInformation
